const PbxxRecord = require('../pbxx_record')

module.exports = class CommunicationAutomation extends PbxxRecord {
  static get class_name() {
    return 'CommunicationAutomation'
  }
}
